import {Component, Inject, Input} from '@angular/core';
import {BLOCKS_CONFIG, BlocksConfig} from '@blocks/blocks.config';
import {Row} from '@paperlessio/sdk/api/models';

@Component({
  selector: 'app-row',
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.scss']
})
export class RowComponent {
  @Input() block: Row;

  get columns() {
    return this.block.children;
  }

  constructor(@Inject(BLOCKS_CONFIG) public blocksConfig: BlocksConfig) {}

}
